import {API_BASE} from '../../apiConfig';

const readJsonSafely = async (response) => {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
};

/**
 * Сетевой слой записи обучения (см. createTutorialReplayRecorder). Ответ
 * отдается как есть — {status, data}; решает, повторять ли, сам рекордер.
 * Сетевой сбой — отклоненный промис.
 */
export const tutorialReplayTransport = {
  async createRun(chapterId, runId, actions = [], {keepalive = false} = {}) {
    const response = await fetch(`${API_BASE}/users/me/tutorial-runs`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      credentials: 'include',
      // Создание при закрытии вкладки: запрос должен дойти и после ее выгрузки
      keepalive,
      body: JSON.stringify({chapterId, runId, actions}),
    });
    return {status: response.status, data: await readJsonSafely(response)};
  },

  async appendActions(matchId, body, {keepalive = false} = {}) {
    const response = await fetch(`${API_BASE}/users/me/tutorial-runs/${encodeURIComponent(matchId)}/actions`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      credentials: 'include',
      // Страница закрывается: запрос должен дойти и после ее выгрузки
      keepalive,
      body: JSON.stringify(body),
    });
    return {status: response.status, data: await readJsonSafely(response)};
  },
};

/**
 * Вкладку закрывают, перезагружают или сворачивают (на телефоне свернутую
 * вкладку система может выгрузить без предупреждения) — повод отправить
 * накопленное немедленно
 */
export const subscribeToTutorialReplayPageHide = (onHide) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return () => {};
  }
  const handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      onHide();
    }
  };
  window.addEventListener('pagehide', onHide);
  document.addEventListener('visibilitychange', handleVisibilityChange);
  return () => {
    window.removeEventListener('pagehide', onHide);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
};
